<script lang="ts" setup>
import VCard from '@components/card/VCard/VCard.vue';
import { TRANSLATION_GROUP_CREATIVES_LINK } from '@modules/creatives-link/constants';
import { useCreativesLinkPage } from '@modules/creatives-link/pages/CreativesLinkPage/composables';
import VForm from '@modules/forms/components/VForm/VForm.vue';

const {
  formSchema,
  formGroups,
  onChange,
  onSubmit,
} = useCreativesLinkPage();
</script>

<template>
  <VCard v-data-qa-auto-id="'CreativesLinkPage'"
    :title="$getTranslation(TRANSLATION_GROUP_CREATIVES_LINK, 'HEADER')"
    type="form"
  >
    <VForm
      :schema="formSchema"
      :groups="formGroups"
      :submit-btn-label="$getTranslation(TRANSLATION_GROUP_CREATIVES_LINK, 'GET_LINK_BTN')"
      @change="onChange"
      @submit="onSubmit($event)"
    />
  </VCard>
</template>
